export const windowBreakPoints = [1366, 1024, 900];
